

const AgentReducer = (state, action) => {
    switch (action.type) {
        case "GET_AGENTS_START":
            return {
                ...state,
                agents: [],
                isFetching: true,
                error: false,
            };
        case "GET_AGENTS_SUCCESS":
            return {
                ...state,
                agents: action.payload.agents,
                count: action.payload.count,
                isFetching: false,
                error: false,
            };
        case "GET_AGENTS_FAILURE":
            return {
                ...state,
                agents: [],
                isFetching: false,
                error: action.payload,
            };
        case "ADD_AGENT_START":
            return {
                ...state,
                agent: {},
                isFetchingAdd: true,
                errorAdd: false,
            };
        case "ADD_AGENT_SUCCESS":
            return {
                ...state,
                agent: action.payload.agent,
                isFetchingAdd: false,
                errorAdd: false,
            };
        case "ADD_AGENT_FAILURE":
            return {
                ...state,
                agent: {},
                isFetchingAdd: false,
                errorAdd: action.payload,
            };
        case "UPDATE_AGENT_START":
            return {
                ...state,
                agent: {},
                isFetchingUpdate: true,
                errorUpdate: false,
            };
        case "UPDATE_AGENT_SUCCESS":
            return {
                ...state,
                agent: action.payload.agent,
                isFetchingUpdate: false,
                errorUpdate: false,
            };
        case "UPDATE_AGENT_FAILURE":
            return {
                ...state,
                agent: {},
                isFetchingUpdate: false,
                errorUpdate: action.payload,
            };
        case "ACTIVATE_AGENT_START":
            return {
                ...state,
                agent: {},
                isFetchingActivate: true,
                errorActivate: false,
            };
        case "ACTIVATE_AGENT_SUCCESS":
            return {
                ...state,
                agent: action.payload.agent,
                isFetchingActivate: false,
                errorActivate: false,
            };
        case "ACTIVATE_AGENT_FAILURE":
            return {
                ...state,
                agent: {},
                isFetchingActivate: false,
                errorActivate: action.payload,
            };
        default:
            return { ...state };
    }
}

export default AgentReducer;